import {
  Folder,
  FolderContent,
  GalleryContent,
  PanoramaContent,
  UploadView,
  WebStandaloneContent,
} from '../services/UploadManagementServiceTypes';
import { PublicConfig } from '../../config/types';

export const createSharedFolderUrl = (sharedAccessKey: string) =>
  `${window.location.origin}/account#!/upload/share/content/${sharedAccessKey}`;

export const createFolderUrl = (folderGuid?: string | null) =>
  `${window.location.origin}/account#!/upload/${folderGuid || ''}`.replace(/\/$/, '');

export const getFolderUrl = (folder: Folder | FolderContent, view: UploadView): string =>
  view === 'shared' ? createSharedFolderUrl(folder.sharedAccessKey) : createFolderUrl(folder.guid);

export const getParentFolderUrl = (folder: Folder, view: UploadView): string => {
  if (view === 'shared') {
    return folder.parentAccessKey ? createSharedFolderUrl(folder.parentAccessKey) : '';
  }

  return createFolderUrl(folder.parentGuid);
};

export const createSharedPanoramaUrl = (panorama: PanoramaContent, config?: PublicConfig) =>
  `${config?.uploadManagement.panoramaApiUrl}/view/link/${panorama.sharedAccessKey}`;

export const createSharedWebstandaloneUrl = (
  webstandalone: WebStandaloneContent,
  config?: PublicConfig,
) => `${config?.uploadManagement.webstandaloneApiUrl}/view/link/${webstandalone.sharedAccessKey}`;

export const getSharedGalleryUrl = (gallery: GalleryContent) =>
  `${window.location.origin}/account#!/panoramaGallery/view/${gallery.sharedAccessKey}`;

export const getGalleryUrl = (gallery: GalleryContent) =>
  `${window.location.origin}/account#!/panoramaGallery/reader/${gallery.guid}`;
